module.exports = __webpack_public_path__ + "static/media/je.e170f442.svg";